



























































import { Component, Vue } from 'vue-property-decorator';
import RegisterForm1 from '@/views/pages/components/register-form1.vue';
import RegisterForm2 from '@/views/pages/components/register-form2.vue';
import RegisterForm3 from '@/views/pages/components/register-form3.vue';
import UiSelectLanguage from '@/components/ui/ui-select-language.vue';
import UserApi from '@/services/rest/bemob/user';

@Component({
  components: {
    RegisterForm1,
    RegisterForm2,
    RegisterForm3,
    UiSelectLanguage
  }
})
export default class Register extends Vue {
  apiUser: UserApi = new UserApi();

  get step() {
    switch (this.$route.name){
      case 'register-email-verification': return 2
      case 'register-currency': return 3
      default: return 1
    }
  }

  get formComponent() {
    switch (this.step){
      case 1: return RegisterForm1
      case 2: return RegisterForm2
      case 3: return RegisterForm3
    }
  }

  onLanguageChange(language:string) {
    if(this.step===2 || this.step===3){
      this.apiUser.patchUser({ language })
        .then((res: any) => {
          this.$store.commit('updateUser', res);
        });
    }
  }
}
